export const CHINESE: string = "Chinese";
export const STANDARD: string = "Standard";
